import MentorClinicAssociations from 'src/supportPortal/components/common/mentor/clinicAssociations/MentorClinicAssociations'

export default function DoctorClinics() {
  return (
    <MentorClinicAssociations
      getAssociatedBrandsApiSignature="/api/secure/cc/support/doctor/clinic-associations"
      getSelectedMentorApiSignature="/api/secure/cc/support/doctor/by-slug"
      hidePayoutReports
      hideEngagementModels
      hidePayoutInvoices
    />
  )
}
